module.exports = __webpack_public_path__ + "static/media/allergysymptoms-2.d5ea01eb.jpg";